import React from 'react';
import { Button } from '../ui/button';
import { Phone, MessageCircle } from 'lucide-react';

const NAV_LINKS = [
  { label: 'Vorteile', id: 'vorteile' },
  { label: 'Preise', id: 'preise' },
  { label: 'Leistungen', id: 'leistungen' },
  { label: 'Ablauf', id: 'ablauf' },
  { label: 'Regionen', id: 'regionen' },
  { label: 'FAQ', id: 'faq' },
  { label: 'Kontakt', id: 'kontakt' }
];

const DesktopNav = ({ onNavigate, onCall, onWhatsApp }) => (
  <>
    <nav className="hidden lg:flex items-center gap-8">
      {NAV_LINKS.map((link) => (
        <button
          key={link.id}
          onClick={() => onNavigate(link.id)}
          className="text-slate-300 hover:text-white font-medium transition-all duration-300 relative group"
        >
          {link.label}
          <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-blue-400 to-purple-400 group-hover:w-full transition-all duration-300"></span>
        </button>
      ))}
    </nav>

    <div className="hidden md:flex items-center gap-3">
      <Button
        onClick={onCall}
        variant="outline"
        size="sm"
        className="border-2 border-blue-500/50 text-blue-400 hover:bg-blue-500/10 hover:border-blue-400 backdrop-blur-sm transition-all duration-300"
        data-testid="header-call-btn"
      >
        <Phone className="w-4 h-4 mr-2" />
        Anrufen
      </Button>
      <Button
        onClick={onWhatsApp}
        size="sm"
        className="bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700 text-white shadow-lg shadow-green-500/20 hover:shadow-green-500/40 transition-all duration-300"
        data-testid="header-whatsapp-btn"
      >
        <MessageCircle className="w-4 h-4 mr-2" />
        WhatsApp
      </Button>
    </div>
  </>
);

export { NAV_LINKS };
export default DesktopNav;
